import { map, get, filter, find } from 'lodash-es';
import uuidv4 from 'uuid/v4';
import { formatAmountCurrency, formatPercent } from '../../../../Utils/Utils';

/**
 * @description return coverages with formated amounts according to currency
 * @param {*} coverages Examples: 12345.67, -0.89
 * @param {*} locales Optional - Examples: 'de-DE', 'DE', 'zh-Hans-CN', ['de-AT', 'de-DE'] - default to 'fr-FR'
 * @param {*} currency Optional - Examples: 'EUR', 'BRL', 'USD' - default to 'EUR'
 * @param {*} options Optional - Examples: { style: 'unit', unit: 'mile-per-hour' }
 * @returns coverages
 */
export const formatCoveragesCurrencies = (coverages = [], locales = 'fr-FR', currency = 'EUR', options) => {
  const formatedCoverages = map(coverages, ({ value, ...coverage }) => ({
    ...coverage,
    value: formatAmountCurrency(value, locales, currency, options),
  }));
  return formatedCoverages;
};

/**
 *
 * @param {*} value
 * @returns
 */
export const isNotEqualToZero = value => {
  if (typeof value === 'number') {
    return value !== 0;
  }
  // try to converts to a number.
  if (typeof value === 'string') {
    const number = Number(value);
    return isNaN(number) ? false : number !== 0;
  }
  // not eligible to be formatted
  return false;
};

/**
 *
 * @param {*} loans
 * @param {*} strings
 * @param {*} ref
 * @returns
 */
export const getTaeaLabel = (strings, ref) => {
  const label = `${get(strings, 'editsalesroute.podium.total.taea', 'TAEA prêt n°')} ${ref + 1}`;

  return label;
};

/**
 * @description getTaeaFromOffers
 * @param {*} offers
 * @param {*} loans
 * @param {*} strings
 * @returns
 */
export const getTaeaFromOffers = (offers = [], loans = [], strings = {}) => {
  // extract taeas for each loans
  const taeas = loans.map((loan, index) => {
    const label = getTaeaLabel(strings, index);
    const loanRef = get(loan, 'ref');
    const packages = map(offers, offer => {
      const packageCode = get(offer, 'package.code');
      const taea = filter(get(offer, 'taea'), ['loan.ref', loanRef])?.[0];
      const value = formatPercent(get(taea, 'taea'));

      return {
        ref: packageCode,
        value,
        offerRef: offer?.ref,
      };
    });

    return {
      id: uuidv4(),
      label,
      type: 'taea',
      packages,
    };
  });

  return taeas;
};

/**
 * @description getFeeFromOffers
 * @param {*} offers
 * @param {*} strings
 * @returns
 */
export const getFeeFromOffers = (offers = [], strings = {}) => {
  const fees = [];
  const fee = {
    id: uuidv4(),
    label: get(strings, 'editsalesroute.podium.total.fee', 'Total frais'),
    type: 'fee',
    packages: map(offers, offer => {
      const packageCode = get(offer, 'package.code');
      const value = formatAmountCurrency(get(offer, 'premium.total_fee'));
      return {
        ref: packageCode,
        value,
        offerRef: offer?.ref,
      };
    }),
  };
  fees.push(fee);

  return fees;
};

/**
 * get party full name (name + last name)
 * @param {*} ref
 */
export const getPartyGenderLabel = (val, strings, compact = false) => {
  switch (val) {
    case 'male':
      return compact
        ? get(strings, 'salesroute.gender.male.compact.label', 'M.')
        : get(strings, 'salesroute.gender.male.label', 'Monsieur');

    case 'female':
      return compact
        ? get(strings, 'salesroute.gender.female.compact.label', 'Mme')
        : get(strings, 'salesroute.gender.female.label', 'Madame');

    default:
      return '';
  }
};

/**
 * get party full name (name + last name)
 * @param {*} ref
 */
export const getFullNameParty = (ref, parties, strings) => {
  const partie = find(parties, { ref });
  const gender = getPartyGenderLabel(get(partie, 'gender'), strings, true);
  const firstName = get(partie, 'first_name');
  const name = get(partie, 'name');
  return `${gender} ${firstName} ${name}`;
};

/**
 * @description  getTitlePart
 * @param {*} questionnaire
 * @param {*} idPart
 * @param {*} isLoanKind
 * @returns
 */
export const getTitlePart = (questionnaire, idPart, isLoanKind, idx, parties, strings) => {
  let title = '';
  if (isLoanKind) {
    title = getFullNameParty(idx, parties, strings);
  } else {
    title = get(find(questionnaire?.parts, { id: idPart }), 'title');
  }

  return title;
};
